import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["toolbar", "share"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { createIcon, useLightboxProps, useLightboxState, isImageSlide, IconButton, addToolbarButton } from '../../index.js';
var defaultShareProps = {
  share: undefined
};

var resolveShareProps = function resolveShareProps(share) {
  return _objectSpread(_objectSpread({}, defaultShareProps), share);
};

function isShareSupported() {
  return typeof navigator !== "undefined" && Boolean(navigator.canShare);
}

var ShareIcon = createIcon("ShareIcon", React.createElement("path", {
  d: "m16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z"
}));

function ShareButton() {
  var _useLightboxProps = useLightboxProps(),
      render = _useLightboxProps.render,
      on = _useLightboxProps.on,
      shareProps = _useLightboxProps.share;

  var _resolveShareProps = resolveShareProps(shareProps),
      customShare = _resolveShareProps.share;

  var _useLightboxState = useLightboxState(),
      currentSlide = _useLightboxState.currentSlide,
      currentIndex = _useLightboxState.currentIndex;

  if (!isShareSupported()) return null;

  if (render.buttonShare) {
    return React.createElement(React.Fragment, null, render.buttonShare());
  }

  var share = currentSlide && (typeof currentSlide.share === "object" && currentSlide.share || typeof currentSlide.share === "string" && {
    url: currentSlide.share
  } || isImageSlide(currentSlide) && {
    url: currentSlide.src
  }) || undefined;
  var canShare = customShare ? (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.share) !== false : share && navigator.canShare(share);

  var defaultShare = function defaultShare() {
    if (share) {
      navigator.share(share).catch(function () {});
    }
  };

  var handleShare = function handleShare() {
    var _a;

    if (currentSlide) {
      (customShare || defaultShare)({
        slide: currentSlide
      });
      (_a = on.share) === null || _a === void 0 ? void 0 : _a.call(on, {
        index: currentIndex
      });
    }
  };

  return React.createElement(IconButton, {
    label: "Share",
    icon: ShareIcon,
    renderIcon: render.iconShare,
    disabled: !canShare,
    onClick: handleShare
  });
}

function Share(_ref) {
  var augment = _ref.augment;
  augment(function (_ref2) {
    var toolbar = _ref2.toolbar,
        share = _ref2.share,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return _objectSpread({
      toolbar: addToolbarButton(toolbar, "share", React.createElement(ShareButton, null)),
      share: resolveShareProps(share)
    }, rest);
  });
}

export { Share as default, isShareSupported };